import { CodesModel, Total } from '@/data/Models'
import store from '@/store'
import zipcelx from 'zipcelx'

const CODES:CodesModel = require('../data/Codes.json')

// Global mixin for all editable input fields
// Will trigger an error message if rules are not satisfied
export const inputs = {
  methods: {
    validate: function (this:any, event:number, field:string) {
      // If empty field or negative value, and field error does not exist
      if ((!event || event < 0 || typeof event !== 'string')) {
        if (store.state.errors.indexOf(field) < 0) {
          store.state.errors.push(field)
        }
        store.state.errorAlert = true
      } else {
        store.state.errors.splice(store.state.errors.indexOf[field], 1)
      }
      if (store.state.errors.length < 1) {
        store.state.errorAlert = false
      }
    }
  }
}

// Print and export functions for tables
export const printExport = {
  methods: {
    // Print the selected table
    printTable: function (this:any, tableId:string) {
      // Get table
      let divToPrint:any = document.getElementById(tableId)

      // Add styles
      divToPrint.style.textAlign = 'center'
      let td:any = document.getElementsByTagName('td')
      td.forEach((element:any) => {
        element.style.outline = '1px solid lightgrey'
      })

      // Open Print window
      let newWin:any = window.open()
      newWin.document.write(divToPrint.outerHTML)
      newWin.print()

      // Remove styles
      divToPrint.style.textAlign = 'inherit'
      td.forEach((element:any) => {
        element.style.outline = 'none'
      })

      // Close
      newWin.close()
    },
    xlsExport (this:any, arrData:any[]) {
      const config = {
        filename: 'p-tool-results-2019',
        sheet: {
          data: arrData
        }
      }
      zipcelx(config)
    },
    printPage () {
      setTimeout(() => { 
        try {
          // Workaround for Safari browser
          document.execCommand('print', false, '');
        } catch (e) {
          // All other browsers
          window.print();
        }
      }, 500);
    }
  }
}

// Generic stock selections and calculations
export const stockCalculations = {
  methods: {
    // Get the different weight for each stock type
    getWeights: function (this:any, stock:any) {
      let items:any[] = []
      switch (stock) {
        case 'Cows':
          items = [400, 500, 600, 700]
          break
        case 'Weaner Cattle':
          items = [150, 200, 250, 300, 350, 400, 450, 500]
          break
        case 'Ewes / Wethers':
          items = [40, 50, 60, 70]
          break
        case 'Lambs':
          items = [15, 25, 35, 45]
          break
      }
      return items
    },

    // Get the different physiological state for each stock type
    getPhysiologicalState: function (this:any, stock:any) {
      let items:any[] = []
      switch (stock) {
        case 'Cows':
          items = ['Dry / Early Preg', 'Late Preg (Last 3 Months)', 'Early Lactation (2 Months)', 'Late Lactation (150kg Calf)']
          break
        case 'Weaner Cattle':
          items = ['Not Applicable']
          break
        case 'Ewes / Wethers':
          items = ['Dry', 'Pregnant (50 Days)', 'Pregnant (70 Days)', 'Pregnant (100 Days)', 'Pregnant (130 Days)', 'Lactating (10 Days)', 'Lactating (30 Days)', 'Lactating (50 Days)']
          break
        case 'Lambs':
          items = ['Not Applicable']
          break
      }
      return items
    },

    // Returns the intake and energy of stock as an array [intake, energy]
    getPastureIntakeEnergy: function (this:any, currentStock?:any, currentPaddock?:any) {
      // Use default stock and paddock if currentPaddock param is not used
      currentStock = currentStock !== undefined ? currentStock : this.stock
      currentPaddock = currentPaddock !== undefined ? currentPaddock : this.paddock || this.pasture
      let stockCode:number = 0,
          weightCode:number = 0,
          stateCode:number = 0,
          pregnancyCode:number = 0,
          fooCodeA:number = 0,
          fooCodeB:number = 0,
          qualityCode:number = 0,
          totalCodeA:number = 0,
          totalCodeB:number = 0,
          resultA:Total[] = [],
          resultB:Total[] = [],
          intake:number = 0,
          energy:number = 0
      // Stock code
      let stock = CODES.stocks.filter((e) => e.stock === currentStock.type)
      stockCode = stock[0] !== undefined ? stock[0].code : 0
      // Weight Code
      let weight = CODES.weights.filter((e) => e.stock === currentStock.type)
      weightCode = weight.length > 0 ? weight[0].weights.filter((e) => e.weight === currentStock.weight).length > 0 ? weight[0].weights.filter((e) => e.weight === currentStock.weight)[0].code : 0 : 0
      // State Code
      let state = CODES.states.filter((e) => e.state === currentStock.state)
      stateCode = state[0] !== undefined ? state[0].code : 0
      // Pregnancy Code
      let pregnancy = CODES.pregnancies.filter((e) => e.pregnancy === currentStock.pregnancy)
      pregnancyCode = pregnancy[0] !== undefined ? pregnancy[0].code : 0
      // Feed On Offer Codes
      if (currentStock.type === 'Ewes / Wethers' || currentStock.type === 'Lambs') {
        switch (true) {
          case (currentPaddock.currentFeed < 1000):
            fooCodeA = CODES.foo['500']
            break
          case (currentPaddock.currentFeed < 1500):
            fooCodeA = CODES.foo['1000']
            break
          case (currentPaddock.currentFeed >= 1500):
            fooCodeA = CODES.foo['1500']
            break
        }
      } else {
        switch (true) {
          case (currentPaddock.currentFeed < 1000):
            fooCodeA = CODES.foo['500']
            break
          case (currentPaddock.currentFeed < 1500):
            fooCodeA = CODES.foo['1000']
            break
          case (currentPaddock.currentFeed < 2000):
            fooCodeA = CODES.foo['1500']
            break
          case (currentPaddock.currentFeed >= 2000):
            fooCodeA = CODES.foo['2000']
            break
        }
      }
      fooCodeB = fooCodeA === 500 ? 600 : fooCodeA === 600 ? 700 : fooCodeA === 700 ? 800 : fooCodeA === 800 ? 800 : fooCodeA
      // Quality Code
      let quality = CODES.qualities.filter((e) => e.quality === currentPaddock.quality)
      qualityCode = quality[0] !== undefined ? quality[0].code : 0
      // Total Code
      totalCodeA = stockCode + weightCode + stateCode + pregnancyCode + fooCodeA + qualityCode
      totalCodeB = stockCode + weightCode + stateCode + pregnancyCode + fooCodeB + qualityCode
      // Result, Intake & Energy
      resultA = CODES.totals.filter((e) => e.code === totalCodeA)
      resultB = CODES.totals.filter((e) => e.code === totalCodeB)
      let a = resultA[0] !== undefined ? resultA[0].intake : 0
      let b = resultB[0] !== undefined ? resultB[0].intake : a
      intake = fooCodeA === 500 ? (((currentPaddock.currentFeed - 500) / 500) * (b - a)) + a
        : fooCodeA === 600 ? (((currentPaddock.currentFeed - 1000) / 500) * (b - a)) + a
          : fooCodeA === 700 ? (((currentPaddock.currentFeed - 1500) / 500) * (b - a)) + a
            : fooCodeA === 800 ? (((currentPaddock.currentFeed - 2000) / 500) * (b - a)) + a
              : a
      energy = resultA[0] !== undefined ? resultA[0].energy : 0

      return [intake, energy]
    }

    // // Returns the intake and energy of stock as an array [intake, energy]
    // getPastureIntakeEnergy: function (this:any, currentStock?:any, currentPaddock?:any) {
    //   // Use default stock and paddock if currentPaddock param is not used
    //   currentStock = currentStock !== undefined ? currentStock : this.stock
    //   currentPaddock = currentPaddock !== undefined ? currentPaddock : this.paddock || this.pasture
    //   let stockCode:any,
    //       weightCode:any,
    //       stateCode:any,
    //       pregnancyCode:any,
    //       fooCodeA:any,
    //       fooCodeB:any,
    //       qualityCode:any,
    //       totalCodeA:any,
    //       totalCodeB:any,
    //       resultA: any,
    //       resultB:any,
    //       intake:any,
    //       energy:any
    //   // Stock code
    //   stockCode = CODES.stocks.filter((e) => e.stock === currentStock.type)
    //   stockCode = stockCode[0] !== undefined ? stockCode[0].code : 0
    //   // Weight Code
    //   weightCode = CODES.weights.filter((e) => e.stock === currentStock.type)
    //   weightCode = weightCode[0] !== undefined ? weightCode[0].weights.filter((e:any) => e.weight === currentStock.weight) : 0
    //   weightCode = weightCode[0] !== undefined ? weightCode[0].code : 0
    //   // State Code
    //   stateCode = CODES.states.filter((e) => e.state === currentStock.state)
    //   stateCode = stateCode[0] !== undefined ? stateCode[0].code : 0
    //   // Pregnancy Code
    //   pregnancyCode = CODES.pregnancies.filter((e) => e.pregnancy === currentStock.pregnancy)
    //   pregnancyCode = pregnancyCode[0] !== undefined ? pregnancyCode[0].code : 0
    //   // Feed On Offer Codes
    //   switch (true) {
    //     case (currentPaddock.currentFeed < 1000):
    //       fooCodeA = CODES.foo['500']
    //       break
    //     case (currentPaddock.currentFeed < 1500):
    //       fooCodeA = CODES.foo['1000']
    //       break
    //     case (currentPaddock.currentFeed < 2000):
    //       fooCodeA = CODES.foo['1500']
    //       break
    //     case (currentPaddock.currentFeed >= 2000):
    //       fooCodeA = CODES.foo['2000']
    //       break
    //   }
    //   fooCodeB = fooCodeA === 500 ? 600 : fooCodeA === 600 ? 700 : fooCodeA === 700 ? 800 : fooCodeA === 800 ? 800 : fooCodeA
    //   // Quality Code
    //   qualityCode = CODES.qualities.filter((e) => e.quality === currentPaddock.quality)
    //   qualityCode = qualityCode[0] !== undefined ? qualityCode[0].code : 0
    //   // Total Code
    //   totalCodeA = stockCode + weightCode + stateCode + pregnancyCode + fooCodeA + qualityCode
    //   totalCodeB = stockCode + weightCode + stateCode + pregnancyCode + fooCodeB + qualityCode
    //   // Result, Intake & Energy
    //   resultA = CODES.totals.filter((e) => e.code === totalCodeA)
    //   resultB = CODES.totals.filter((e) => e.code === totalCodeB)
    //   let a = resultA[0] !== undefined ? resultA[0].intake : 0
    //   let b = resultB[0] !== undefined ? resultB[0].intake : 0
    //   intake = fooCodeA === 500 ? (((currentPaddock.currentFeed - 500) / 500) * (b - a)) + a
    //     : fooCodeA === 600 ? (((currentPaddock.currentFeed - 1000) / 500) * (b - a)) + a
    //       : fooCodeA === 700 ? (((currentPaddock.currentFeed - 1500) / 500) * (b - a)) + a
    //         : fooCodeA === 800 ? (((currentPaddock.currentFeed - 2000) / 500) * (b - a)) + a
    //           : a
    //   energy = resultA[0] !== undefined ? resultA[0].energy : 0

    //   return [intake, energy]
    // }
  }
}

// Used for conditional rendering on touchscreen and non-touchscreen devices
declare global {
  interface Window {
    PointerEvent:any
    TouchEvent:any
  }
}
export const touchScreen = {
  methods: {
    detect () {
      let result = false
      if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
        // if Pointer Events are supported, just check maxTouchPoints
        if (navigator.maxTouchPoints > 0) {
          result = true
        }
      } else {
        // no Pointer Events...
        if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) {
          // check for any-pointer:coarse which mostly means touchscreen
          result = true
        } else if (window.TouchEvent || ('ontouchstart' in window)) {
          // last resort - check for exposed touch events API / event handler
          result = true
        }
      }
      console.log('Is a touchscreen', result)
      return result
    }
  }
}

// Update service workers
export const update = {
  data() {
    return {
      // refresh variables
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
  created(this:any) {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      // Here the actual reload of the page occurs
      window.location.reload()
    })
  },
  methods: {
    // Store the SW registration so we can send it a message
    // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    updateAvailable(this:any, event:any) {
      this.registration = event.detail
      this.updateExists = true
      // Call immediately no user confirmation
      // this.refreshApp()
    },
    // Called when the user accepts the update
    refreshApp(this:any) {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }
}
